<template>
  <Modal :title="title" :showModal="showModal" class="edit-action-form large" @submit="submit">
    <template v-slot:body>
      <div class="row">
        <div class="position-relative form-group col-12">
          <label class="p-0">Name*</label>
          <input class="form-control" type="text" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label class="p-0">Event*</label>
          <Select :options="eventOptions" :value="event" @changeValue="handleChangeEvent" placeholder="Event"></Select>
        </div>
        <div v-if="event" class="position-relative form-group d-flex flex-wrap col-12 mt-3">
          <label class="mb-0 p-0 pr-2">Conditions*</label>
          <i @click="addConditionItem" class="icon ti ti-square-rounded-plus"></i>
          <div class="list-condition w-100 package-conditions">
            <ConditionItem v-for="(condition, key) in conditions" :key="key" :config="{ store, event, condition, more, storeId: `conditions.${key}` }"></ConditionItem>
          </div>
        </div>
        <div v-if="event" class="position-relative form-group d-flex flex-wrap col-12 mt-3">
          <label class="mb-0 p-0 pr-2">Actions*</label>
          <i @click="addActionItem" class="icon ti ti-square-rounded-plus"></i>
          <draggable :model-value="actions" @update:modelValue="changeActionPriority" @start="drag = true" @end="drag = false" v-bind="{ animation: 200 }" handle=".handle" item-key="id" class="list-action w-100 package-actions">
            <template #item="{ element, index }">
              <div :class="`w-100 item`">
                <i class="ti ti-menu-order handle"></i>
                <div class="w-100">
                  <ActionItem :config="{ store, event, action: element, more, storeId: `actions.${index}` }"></ActionItem>
                </div>
              </div>
            </template>
          </draggable>
        </div>
        <div v-if="event" class="position-relative form-group d-flex flex-wrap col-12 mt-3">
          <label class="mb-0 p-0 pr-2">Collections</label>
          <i @click="addCollectionItem" class="icon ti ti-square-rounded-plus"></i>
          <div class="list-condition w-100 package-custom-data">
            <CollectionItem v-for="(collection, key) in collections" :key="key" :config="{ store, collection, more, storeId: `collections.${key}` }"></CollectionItem>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import draggable from 'vuedraggable'
import Event from '@/helper/event.js'
import ConditionItem from './ConditionItem.vue'
import ActionItem from './ActionItem.vue'
import CollectionItem from './CollectionItem.vue'
export default {
  components: {
    ConditionItem,
    ActionItem,
    CollectionItem,
    draggable
  },
  mixins: [Event],
  computed: {
    title() {
      return this.data.status == 'draft' ? 'Create Action' : 'Edit Action'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    actionId() {
      return this.config?.data?._id
    },
    getUri() {
      return `automation/get/${this.actionId}`
    },
    submitUri() {
      return `automation/update/${this.actionId}`
    },
    data() {
      return this.store.getter('', {})
    },
    event() {
      return this.data.event || ''
    },
    eventOptions() {
      let events = []
      Object.entries(this.more.events || {}).forEach(([key, value]) => {
        events.push({
          id: key,
          text: value.label
        })
      })
      return events
    },
    actions() {
      return this.data.actions || []
    },
    conditions() {
      return this.data.conditions || []
    },
    collections() {
      return this.data.collections || []
    },
    more() {
      return this.data.more || {}
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    setUpData({ status, data }) {
      if (status == 'success') {
        this.showModal = true
        this.store.commit('', data)
      }
    },
    handleChangeEvent(e) {
      this.store.commit('event', e)
    },
    addConditionItem() {
      let conditions = this.store.getter(`conditions`, [])
      conditions.unshift({})
      this.store.commit(`conditions`, conditions)
    },
    addActionItem() {
      let actions = this.store.getter(`actions`, [])
      actions.unshift({})
      this.store.commit(`actions`, actions)
    },
    changeActionPriority(value) {
      this.store.commit('actions', value)
    },
    addCollectionItem() {
      let conditions = this.store.getter(`collections`, [])
      conditions.unshift({})
      this.store.commit(`collections`, conditions)
    },
    submit() {
      let data = Object.assign({}, this.data)
      this.submitForm(data, {
        done: (response) => {
          if (response.status == 'success') {
            this.$emit('close')
            this.$emitter.emit('TableList.Refresh')
          }
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.edit-action-form {
  .w-100 {
    margin-top: 10px;
    padding-left: 0;
  }
  .icon {
    font-size: 24px;
    cursor: pointer;
  }
  .list-action {
    .item {
      position: relative;
    }
    .package-item .package {
      padding-left: 40px;
    }
    i.handle {
      cursor: move;
      font-size: 20px;
      color: #4b4b4b;
      border: 1px solid;
      border-radius: 5px;
      padding: 2px;
      margin-right: 10px;
      position: absolute;
      z-index: 9;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
